/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/listPharms',
        name: 'ListPharms',
        component: page('ListPharmList'),
        iconCls: 'el-icon-document',
        order: 504
    },
    {
        path: '/listPharms/:id',
        name: 'Show ListPharm',
        component: page('ListPharmView'),
        hidden: true
    }
]
